import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConvertDateToBigEndianPipe } from './convert-date-to-big-endian.pipe';
import { GroupOrderItemsPipe } from './group-order-items.pipe';
import { ObjectKeysPipe } from './object-keys.pipe';
import { ReversePipe } from './reverse.pipe';
import { ShowTopThreePipe } from './show-top-three.pipe';
import { TranslateCut } from './translate-cut.pipe';

/**
 * Module for pipes
 */
@NgModule({
  declarations: [
    ConvertDateToBigEndianPipe,
    GroupOrderItemsPipe,
    ObjectKeysPipe,
    ReversePipe,
    ShowTopThreePipe,
    TranslateCut
  ],
  exports: [
    ConvertDateToBigEndianPipe,
    GroupOrderItemsPipe,
    ObjectKeysPipe,
    ReversePipe,
    ShowTopThreePipe,
    TranslateCut
  ],
  imports: [
    CommonModule
  ]
})
export class PipesModule { }
